export default {
    root: {
      
    },
    paperFullWidth: {
        // border: '2px solid #00336e',
    }
  };
  